export const setHuntPlannerMapReference = (map) => {
    return {
        type: 'SET_HUNT_PLANNER_MAP_REFERENCE',
        payload: map
    }
}

export const setHuntPlannerMapReferenceNull = () => {
    return {
        type: 'SET_HUNT_PLANNER_MAP_REFERENCE_NULL',
    }
}